import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Login = () => import('@/views/Login')
const Layouts = () => import('@/views/layouts/layouts')
const Home = () => import('@/views/Home.vue')

const System = require('@/router/system.js')
const Users = require('@/router/users.js')
const Shop = require('@/router/shop.js')
const Order = require('@/router/order.js')
const Prize = require('@/router/prize.js')

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      meta: { title: '登陆管理系统' },
      component: Login
    },
    {
      path: '/',
      component: Layouts,
      meta: { title: '首页', level: 1, icon: 'el-icon-s-home' },
      children: [
        {
          meta: { title: '首页' },
          path: '',
          name: 'home',
          component: Home
        }
      ]
    },
    {
      path: '/system',
      component: Layouts,
      redirect: '/system/smanage',
      meta: { title: '系统管理', level: 2, icon: 'el-icon-s-tools', route: 'system' },
      children: System.router
    },
    {
      path: '/user',
      component: Layouts,
      redirect: '/user/users',
      meta: { title: '用户管理', level: 2, icon: 'el-icon-user-solid', route: 'users' },
      children: Users.router
    },
    {
      path: '/shop',
      component: Layouts,
      redirect: '/shop/goods-category',
      meta: { title: '商城管理', level: 2, icon: 'el-icon-s-shop', route: 'shop' },
      children: Shop.router
    },
    {
      path: '/order',
      component: Layouts,
      redirect: '/order/oil-order',
      meta: { title: '订单管理', level: 2, icon: 'el-icon-s-order', route: 'order' },
      children: Order.router
    },
    {
      path: '/prize',
      component: Layouts,
      redirect: '/prize/user-prize',
      meta: { title: '抽奖管理', level: 2, icon: 'el-icon-s-cooperation', route: 'prize' },
      children: Prize.router
    }
  ]
})
